import { get } from '../utils/httpClient'
import { FeaturesResponse } from '../redux/features/features.types'
import { getRedDataApiPaths } from '../config'

export const apiGetFeatures = async (projectId: string, sessionId: string) => {
  const response = (await get(getRedDataApiPaths().RED_API_FEATURES(projectId, sessionId), false)) as FeaturesResponse
  return response.features
}
